import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/** Fades content up into view once, as it scrolls in. */
const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.21, 0.6, 0.35, 1] }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
